export default function ({ redirect }) {
    // ユーザが認証されていないとき
    if (this.$auth.user.role !== this.$role.user) {
        return redirect(this.$page.login);
    }
}